import { POST } from '~/consts';

export const state = () => ({
  show_add_box: false,
  detail: {
    is_edit: false,
    loading_get: false,
    show_all_medias: false,
    post: null,
    comments: [],
    loading_reply: false,
    loading_get_comments: false,
    commentData: {
      content: ''
    }
  }
})

export const mutations = {
  toggleBox (state, val) {
    state.show_add_box = val;
  },
  toggleLoadingGet (state, val) {
    state.detail.loading_get = val;
  }
}

export const actions = {
  async getAll({ commit }, { groupId, dataProvider, groupTeamId = null}) {
    let data = { dataProvider, group_team_id: groupTeamId };

    return await this.$axios.post(`${POST.GET_ALL(groupId)}?comment=true`, data)
  },
  async storePost({ commit }, { groupId, postData}) {
    return await this.$axios.post(`${POST.ADD(groupId)}`, postData);
  },
  async updatePost({ commit }, { postId, postData}) {
    return await this.$axios.post(`${POST.UPDATE(postId)}`, postData);
  },
  async destroy({ commit }, id) {
    return await this.$axios.post(POST.DESTROY(id), {id});
  }
}
